/* eslint-disable jsx-a11y/alt-text */
import React from "react"
import { Flex } from "rebass"
import { get } from "lodash"
import BannerAnim from "rc-banner-anim"
// import "rc-banner-anim/assets/index.css"
import RightImageElement from "./RightImageElement"
import LeftImageElement from "./LeftImageElement"

const { Element } = BannerAnim
const BgElement = Element.BgElement

const CarouselList = (props) => {
  const { data, widthContainer } = props
  const paddingTop = get(data, "container.paddingTopQuery", ["76px", "123px"])
  const bgColor = get(data, "container.backgroundColor", "#650101")
  const typeBanner = get(data, "container.type", "across")
  const isAuto = false //const isAuto = get(data, "container.auto", false)
  const heightContainer = get(data, "container.height", "570px")
  const list = get(data, "list", [])
  return (
    <Flex
      w={1}
      direction="column"
      pt={widthContainer < 480 ? ["76px"] : paddingTop}
      style={{ backgroundColor: bgColor }}
    >
      <BannerAnim
        type={typeBanner}
        autoPlay={isAuto}
        style={{ height: heightContainer }}
      >
        {list.map((item, index) => {
          const isBgImage = get(item, "bg.isBgImage", false)
          const useMobile =
            widthContainer <= 832
              ? get(
                  item,
                  "url_bg_mobile",
                  get(
                    item,
                    "url_bg",
                    "https://via.placeholder.com/400x400?text=400x400=CMS"
                  )
                )
              : get(
                  item,
                  "url_bg",
                  "https://via.placeholder.com/480x480?text=480x480=CMS"
                )
          const bgImage = isBgImage
            ? {
                backgroundImage: `url(${useMobile})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }
            : {}
          if (item.position_image === "left") {
            return (
              <Element key={index} prefixCls="banner-user-elem">
                <BgElement key="bg" className="bg" style={bgImage} />
                <LeftImageElement
                  data={item}
                  key={index}
                  id={index}
                  matches={widthContainer <= 832}
                  widthContainer={widthContainer}
                />
              </Element>
            )
          }
          return (
            <Element key={index} prefixCls="banner-user-elem">
              <BgElement key="bg" className="bg" style={bgImage} />
              <RightImageElement
                data={item}
                key={index}
                id={index}
                matches={widthContainer <= 832}
                widthContainer={widthContainer}
              />
            </Element>
          )
        })}
      </BannerAnim>
    </Flex>
  )
}

export default CarouselList



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Layout/carouselAnimation/CarouselList.js